import { AimsCommonPopupEditorData } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-inventory-adjustment-popup',
  templateUrl: './inventory-adjustment-popup.component.html',
  styleUrls: ['./inventory-adjustment-popup.component.css']
})
export class InventoryAdjustmentPopupComponent implements OnInit {

  public formGroup: any;
  public itemToAdjust;
  public updatedQuantity: number;
  public quantity: number;
  public adjustmentNote: string;


  constructor(contentData: AimsCommonPopupEditorData) {
    this.itemToAdjust = contentData.contentData.itemToAdjust;
    this.formGroup = contentData.formGroup;
    this.quantity = contentData.contentData.quantity;

    this.formGroup.addControl('adjustedQuantity', new FormControl(this.quantity, [Validators.required]));
    this.formGroup.addControl('adjustmentNote', new FormControl(this.adjustmentNote, [Validators.maxLength(80), Validators.required]));

      this.formGroup.get('adjustedQuantity').valueChanges.subscribe((v:number)=> {
       console.log(v);
      });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(){
  //  this.formGroup.valueChanges.unsubscribe();
  }

}
